export default __webpack_public_path__ + "static/2123-eba2a68a54df46da590cc1ced0b4c95e.gif";